import React from 'react';

import styles from './Button.module.scss';

export default (props) => (<button className={styles.Button}{...props}>
    <div className={styles.buttonTextWhite}><span className={styles.buttonTextGrey}>{props.children}</span>{props.children}</div></button>);